import { render, staticRenderFns } from "./VisaDirectRecipient.vue?vue&type=template&id=3be1f92d&scoped=true&"
import script from "./VisaDirectRecipient.vue?vue&type=script&lang=js&"
export * from "./VisaDirectRecipient.vue?vue&type=script&lang=js&"
import style0 from "./VisaDirectRecipient.vue?vue&type=style&index=0&lang=css&"
import style1 from "./VisaDirectRecipient.vue?vue&type=style&index=1&id=3be1f92d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be1f92d",
  null
  
)

export default component.exports